// This file should only contain action type constants.

export const SET_QUICK_SPECS = 'SET_QUICK_SPECS';
export const SET_VEHICLE_TYPE = 'SET_VEHICLE_TYPE';
export const SET_QUICK_SPECS_IDC = 'SET_QUICK_SPECS_IDC';
export const SET_ATTRIBUTES_FROM_IDC = 'SET_ATTRIBUTES_FROM_IDC';
export const SET_IS_ELECTRIC = 'SET_IS_ELECTRIC';
